import React, { FC, useState, useEffect } from 'react'
import { throttle } from 'lodash'
import {
  StyledModulePreviewSection,
  LessonPreviewItem,
  LessonPreviewTooltip,
  PreviewLessonType
} from '.'
import { ModuleType } from '../../types'
import { Heading, ScrollRow } from '../System'

type Props = {
  module: ModuleType;
}

const ModulePreviewSection: FC<Props> = ({ module }) => {
  const [previewedLesson, setPreviewLesson] = useState<PreviewLessonType>()

  const hidePreviewLesson = throttle(() => {
    setPreviewLesson(undefined)
  }, 100)

  useEffect(() => {
    // Captures all scroll events
    document.addEventListener('scroll', hidePreviewLesson, true)

    return () => {
      document.removeEventListener('scroll', hidePreviewLesson, true)
    }
  }, [])

  return (
    <StyledModulePreviewSection className="module-preview-row">
      <div className="module-heading">
        <Heading type="h3">
          {module.label && `${module.label}: `}
          {module.title}
        </Heading>
      </div>
      {module.lessons && (
        <ScrollRow itemsToShow={4}>
          {module.lessons.map((lesson, index) => {
            return (
              <LessonPreviewItem
                setPreviewLesson={(lesson?: PreviewLessonType) => setPreviewLesson(lesson)}
                lesson={lesson}
                index={index}
                key={index}
              />
            )
          })}
        </ScrollRow>
      )}
      {previewedLesson && (
        <LessonPreviewTooltip
          lesson={previewedLesson}
          hideTooltip={() => setPreviewLesson(undefined)}
        />
      )}
    </StyledModulePreviewSection>
  )
}

export default ModulePreviewSection
